import { I } from "@/components/Icon";
import { StSectionHead } from "./_shared";

export function OtherTab() {
  return (
    <>
      <StSectionHead
        title="Other"
        desc="Advanced toggles, danger zone, and experimental features land here."
      />
      <div
        className="card card-pad"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 240,
          flexDirection: "column",
          gap: 10,
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 12,
            background: "var(--c-surface-sunk)",
            display: "grid",
            placeItems: "center",
            color: "var(--c-text-3)",
          }}
        >
          {I.sliders}
        </div>
        <div style={{ fontSize: 13.5, fontWeight: 500 }}>Nothing here yet</div>
        <div className="muted" style={{ fontSize: 12.5 }}>
          Reserved for org-level toggles in upcoming releases.
        </div>
      </div>
    </>
  );
}
